





















import Vue from 'vue';
import ReservationDetails from '@/components/ReservationDetails.vue';
import ReservationLocation from '@/components/ReservationLocation.vue';

export default Vue.extend({
	name: 'ReservationSidebar',
	components: { ReservationDetails, ReservationLocation },
});
